import React, { Component } from "react";
import { Link } from "react-router-dom";
// styles for page
import "./authentication.css";
// images for page
import Logo from "../assets/images/logo.png";
import Loader from "../assets/images/loader.svg";
import LeftPartBg from "../assets/images/register/80a8f0b0-ef84-4333-b37c-214d0a55f9a6.png";
//request module
import axios from "axios";
// icon pack
import Ionicon from "react-ionicons";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailValid: null,
      passwordValid: null,
      authError: false,
      emailTypeLoader: false,
      passwordTypeLoader: false,
      stateLoader: false,
      eyeStateIcon: "ios-eye"
    };
    // form elements
    this.buttonActive = null;
    this.emailAlertClass = null;
    this.passAlertClass = null;
    this.iconSize = "50px";
    // password ee variables
    this.eyeActive = null;
    this.activeObject = 0;
    this.eyeObject = [
      {
        type: "password",
        icon: "ios-eye"
      },
      {
        type: "text",
        icon: "ios-eye-off"
      }
    ];
    //  on type timer
    this.timer = null;
    this.typeDelay = 700;
  }
  componentDidMount = () => {
    // initiallize
    this.eyeActive = false;
    this.buttonActive = false;
  };

  componentDidUpdate = () => {
    let authError = this.state.authError;
    // hide error message after 2000 miliseconds
    if (authError) {
      window.setTimeout(() => {
        this.setState({
          authError: false
        });
      }, 2000);
    }
  };
  // form submit
  handleSubmit = e => {
    e.preventDefault();
    this.checkLogin();
  };
  checkLogin = data => {
    window.location.assign(`/dashboard`);
  };
  // change authentication field value,and set values to validate
  handleChange = e => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState(
      {
        [name]: value,
        // values for validate
        fieldToValidateName: name,
        fieldToValidateValue: value
      },
      this.state[name + "TypeLoader"] === false ? this.timerLoader(name) : null
    );
  };
  // delay on field type,show/hide loader
  timerLoader = n => {
    // reset timer
    window.clearTimeout(this.timer);
    // turn on loader ,turn off validation
    this.setState({
      [n + "TypeLoader"]: true,
      [n + "Valid"]: null
    });
    // turn off loader
    setTimeout(() => {
      this.setState({ [n + "TypeLoader"]: false });
    }, 400);

    // // after delay, callback validation function
    this.timer = setTimeout(() => {
      this.checkValidation();
    }, this.typeDelay);
  };
  // validate email password fields
  checkValidation = () => {
    let argName = this.state.fieldToValidateName;
    let argValue = this.state.fieldToValidateValue;
    console.log(argValue);
    // check email validation
    let em,
      pass = null;
    if (argName === "email") {
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(argValue)) {
        em = false;
      } else {
        em = true;
      }
      this.setState({
        emailValid: em
      });
    }
    // check password validation
    if (argName === "password") {
      if (argValue.length > 5) {
        pass = true;
      } else {
        pass = false;
      }
      this.setState(
        {
          passwordValid: pass
        },
        this.checkEyeVisibility(argValue.length)
      );
    }
  };
  // submit button disable/enable
  checkButtonState = () => {
    if (this.state.emailValid && this.state.passwordValid) {
      this.buttonActive = true;
    }
    if (!this.state.emailValid || !this.state.passwordValid) {
      this.buttonActive = false;
    }
  };
  // check  password eye show/hide
  checkEyeVisibility = val => {
    if (val > 0) {
      this.eyeActive = true;
    }
    if (val == 0) {
      this.eyeActive = false;
    }
  };
  //input type  password/text toggle
  showPasswordToggle = arg => {
    let key = (this.activeObject = Number(!arg));
    let input = document.getElementById("passField");
    input.setAttribute("type", this.eyeObject[key].type);
    this.setState({
      eyeStateIcon: this.eyeObject[key].icon
    });
  };

  render() {
    this.checkButtonState();
    // email validation alert
    const emailValidHTML = this.state.emailValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="#36c547"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">Enter valid email adress</span>
      </React.Fragment>
    );
    // password validation alert
    const passValidHTML = this.state.passwordValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="#36c547"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">{`minimum length 6 characters`}</span>
      </React.Fragment>
    );

    const eyePassword = (
      <span onClick={() => this.showPasswordToggle(this.activeObject)}>
        <Ionicon
          icon={this.state.eyeStateIcon}
          fontSize={"40px"}
          className="showPassword"
          color="#323b43"
        />
      </span>
    );
    // field alert style
    if (this.state.emailValid !== null) {
      this.state.emailValid
        ? (this.emailAlertClass = "succes")
        : (this.emailAlertClass = "warrning");
    }
    if (this.state.passwordValid !== null) {
      this.state.passwordValid
        ? (this.passAlertClass = "succes")
        : (this.passAlertClass = "warrning");
    }
    return (
      <React.Fragment>
        <div className="authPage">
          <div className="leftPart grayBg">
            <img src={LeftPartBg} />
          </div>
          <div className="rightPart">
            <div className="Form ">
              <form onSubmit={this.handleSubmit}>
                <img src={Logo} />
                <div className="formHeading">Log in</div>
                <label className="centered grayTxt">
                  Need a JundgleProof account?&nbsp;
                  <Link to="/register" className="btnLink">
                    Create an account
                  </Link>
                </label>
                <label className="labelRelative">
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    onChange={this.handleChange}
                    onBlur={this.checkValidation}
                    value={this.state.email}
                    className={this.emailAlertClass}
                    ref="email"
                  />
                  {this.state.emailValid !== null ? emailValidHTML : null}
                  {this.state.emailTypeLoader ? (
                    <span className="typeLoader">
                      <img src={Loader} />
                    </span>
                  ) : null}
                </label>
                <label className="labelRelative">
                  <input
                    type="password"
                    placeholder="Password"
                    name="password"
                    onChange={this.handleChange}
                    id="passField"
                    value={this.state.password}
                    className={this.passAlertClass}
                  />
                  {this.eyeActive ? eyePassword : null}
                  {this.state.passwordValid !== null ? passValidHTML : null}
                  {this.state.passwordTypeLoader ? (
                    <span className="typeLoader">
                      <img src={Loader} />
                    </span>
                  ) : null}
                </label>
                {this.state.authError ? (
                  <label className="authMessage">
                    The email or password you have entered is invalid.
                  </label>
                ) : null}
                <button
                  className="buttonMid"
                  type="submit"
                  disabled={!this.buttonActive}
                >
                  <span>LOGIN</span>
                </button>
                <label className="centered grayTxt bottomLabel">
                  Don’t remember your Password? &nbsp;
                  <Link to="/reset" className="btnLink">
                    Reset Password
                  </Link>
                </label>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
